import { createSlice } from '@reduxjs/toolkit'
import { viewerInstance } from '../helpers/ViewerHelper'
import { resetInitHomePageState } from './initHomepageSlice'
import { resetErrorPageState } from './errorSlice'


const initialState = {}

export const resetSlice = createSlice({
  name: 'reset',
  initialState,
  reducers: {}
})

// export const {} = resetSlice.actions

export const resetStateForNewOrder = () => (dispatch, getState) => {
  const { accessoryModeEnabled } = getState().accessory
  if (accessoryModeEnabled)
  if (viewerInstance) {
    viewerInstance.clearScene()
  }
}

export const resetAppState = () => async (dispatch, getState) => {
  // dispatch(resetAuthState())
  if (viewerInstance) {
    viewerInstance.clearScene()
  }

  dispatch(resetInitHomePageState())
  dispatch(resetErrorPageState())
}

export default resetSlice.reducer
